/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const updateProfilePostRequestSchema = z.object({
  user_attributes: z.array(
    z.object({
      Name: z.string(),
      Value: z.string(),
    })
  ),
});
